export default "__VITE_ASSET__b2aefde5__"